import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
    selector: 'app-coach-dropdown',
    templateUrl: './coach-dropdown.component.html',
    styleUrls: ['./coach-dropdown.component.scss'],
})
export class CoachDropdownComponent implements OnInit {
    @Output() onButtonClick = new EventEmitter();
    @Output() onBarClick = new EventEmitter<boolean>();
    @Input() title: string;
    @Input() date: string;
    @Input() hasDate = true;
    @Input() color = '';
    @Input() opened = false;
    @Input() disabled = false;
    @Input() isButton = false;
    @Input() isButtonDisabled = false;
    @Input() set status(status: boolean) {
        console.log(this.title, this.opened, status);
        if (this.opened !== status) {
            this.opened = status;
            console.log(this.title, this.opened);
        }
    }

    constructor() {
    }

    ngOnInit() {
    }

    buttonClick(event) {
        event.stopPropagation();
        this.onButtonClick.emit();
    }

    barClick(event) {
        if (!this.disabled) {
            this.opened = !this.opened;
        }
        this.onBarClick.emit(this.opened);
    }

}
